import { apiRequest, getRestErrorMessage } from 'common-src/features/rest';

const extractResponseBody = async (response) => {
  const body = await response.json();

  if (!response.ok) {
    throw new Error(getRestErrorMessage(body) || `Request failed with status ${response.status}`);
  }

  return body;
};

export const fetchOrchestrationTaskTitleOverrides = async () => {
  const response = await apiRequest({ endpoint: 'orchestrationTaskTitles/overrides' });

  return extractResponseBody(response);
};
